import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IUser } from './interfaces/app.interface';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class UserService {

  public currentUserSubject: BehaviorSubject<IUser>;
  public currentUser: Observable<any>;

  constructor() {
    this.currentUserSubject = new BehaviorSubject<IUser>({email :'', firstName :'', lastName : ''});
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): IUser {
    return this.currentUserSubject.value;
  }


}
